/**
 * Abort when any of the given signals aborts.
 * @param {...AbortSignal|undefined|null} signals
 * @returns {AbortSignal}
 */
export function anyAbortSignal(...signals) {
  const valid = signals.filter((s) => s != null)
  const controller = new AbortController()
  if (valid.length === 0) return controller.signal
  for (const s of valid) {
    if (s.aborted) {
      controller.abort()
      return controller.signal
    }
  }
  const onAbort = () => {
    if (!controller.signal.aborted) controller.abort()
  }
  for (const s of valid) {
    s.addEventListener('abort', onAbort, { once: true })
  }
  return controller.signal
}

const DEFAULT_TIMEOUT_MS = 25000

/**
 * Like fetch(), but aborts after timeoutMs if the response never completes.
 * If init.signal is set, abort from either the caller or the timer applies.
 */
export function fetchWithTimeout(input, init = {}, timeoutMs = DEFAULT_TIMEOUT_MS) {
  const ms = Math.max(1000, Number(timeoutMs) || DEFAULT_TIMEOUT_MS)
  const timeoutController = new AbortController()
  const timer = setTimeout(() => timeoutController.abort(), ms)
  const mergedSignal = anyAbortSignal(init.signal, timeoutController.signal)
  return fetch(input, { ...init, signal: mergedSignal }).finally(() => clearTimeout(timer))
}
